import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';

const CartDeliveryNotice = () => {

    const [notice, editNotice] = useState(false);

    useEffect( ()=>{
        getNotice();
    }, [])

    const getNotice = async () => {
        try {
            const url = process.env.NEXT_PUBLIC_API + '/api/cart/order/delivery/notice';
            const response = await axios({
                url,
                method: 'get',
                withCredentials: true,
                headers: { 'Content-Type': 'application/json'},
            });
            const data = response.data;
            if (data.status) {
                editNotice(data.message);
            }
        } catch(err) {

        }
    }


    return (
        notice &&
        <Alert variant="warning" className="mt-3">{notice}</Alert>
    );
}

export default CartDeliveryNotice;